import { Component } from '@angular/core';
import {DashboardGestao} from "../../models/dashboard-gestao";
import {DashboardService} from "../../services/dashboard.service";

@Component({
    selector: 'app-dashboard-gestao',
    templateUrl: './dashboard-gestao.component.html',
    styleUrl: './dashboard-gestao.component.css',
    standalone: false
})
export class DashboardGestaoComponent {
  loading = true;
  fatura= true;
  empresa = false;
  faq = false;
  help = false;
  feedback = false;
  notificacao = false;
  dashboardGestao = new DashboardGestao();

  constructor(private dashboardService: DashboardService) {
    this.buscarDashboardGestao();
  }

  private buscarDashboardGestao(): void {
    this.dashboardService.buscarDashboardGestao().subscribe(response => {
      this.loading = false;
      if(response.sucesso){
        this.dashboardGestao = response.dados;
      }
    }, error =>{
      this.loading = false;
    });
  }

  showFatura(){
    this.fecharTodos();
    this.fatura = true;
  }
  showEmpresa(){
    this.fecharTodos();
    this.empresa = true;
  }
  showFaq(){
    this.fecharTodos();
    this.faq = true;
  }
  showHelp(){
    this.fecharTodos();
    this.help = true;
  }
  showFeedback(){
    this.fecharTodos();
    this.feedback = true;
  }
  showNotificacao(){
    this.fecharTodos();
    this.notificacao = true;
  }
  fecharTodos(){
    this.fatura= false;
    this.empresa = false;
    this.faq = false;
    this.help = false;
    this.feedback = false;
    this.notificacao = false;
  }
}
